"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "nav" };
const _hoisted_2 = { class: "nav-item" };
const _hoisted_3 = ["href"];
const _hoisted_4 = { class: "nav-item" };
const _hoisted_5 = ["href"];
const _hoisted_6 = {
    key: 0,
    class: "pro-label pro-label-navbar"
};
const _hoisted_7 = { class: "nav-item" };
const _hoisted_8 = ["href"];
const _hoisted_9 = {
    key: 0,
    class: "pro-label pro-label-navbar"
};
const _hoisted_10 = { class: "nav-item" };
const _hoisted_11 = ["href"];
const _hoisted_12 = {
    key: 0,
    class: "pro-label pro-label-navbar"
};
const _hoisted_13 = {
    key: 0,
    class: "nav-item"
};
const _hoisted_14 = ["href"];
const _hoisted_15 = {
    key: 0,
    class: "pro-label pro-plus pro-label-navbar"
};
const _hoisted_16 = { class: "nav-item" };
const _hoisted_17 = ["href"];
const _hoisted_18 = { class: "icon-with-badge sidebar-icon" };
const _hoisted_19 = {
    key: 0,
    class: "circle-container comment-number-badge alert-badge"
};
const _hoisted_20 = {
    key: 0,
    class: "zmdi zmdi-alert-circle zmdi-hc-lg alert-icon oplus-delete-text flex-center"
};
const _hoisted_21 = {
    key: 1,
    class: "nav-item"
};
const _hoisted_22 = ["href"];
const vue_3 = require("vue");
const SidebarToggleIcon_vue_1 = __importDefault(require("../../assets/icons/SidebarToggleIcon.vue"));
const BranchTallIcon_vue_1 = __importDefault(require("../../assets/icons/BranchTallIcon.vue"));
const BranchSearchIcon_vue_1 = __importDefault(require("../../assets/icons/BranchSearchIcon.vue"));
const BillingIcon_vue_1 = __importDefault(require("../../assets/icons/BillingIcon.vue"));
const StaffManagementIcon_vue_1 = __importDefault(require("../../assets/icons/StaffManagementIcon.vue"));
const RoleManagementIcon_vue_1 = __importDefault(require("../../assets/icons/RoleManagementIcon.vue"));
const SettingsIcon_vue_1 = __importDefault(require("../../assets/icons/SettingsIcon.vue"));
const TimeIcon_vue_1 = __importDefault(require("../../../vue/icons/TimeIcon.vue"));
const provider_1 = require("../../../provider/provider");
const dashboard_1 = require("../../../js/dashboard");
exports.default = (0, vue_1.defineComponent)({
    __name: 'GroupLevelSidebar',
    setup(__props) {
        const viewModel = (0, vue_3.inject)(provider_1.groupLevelSidebarViewModelInjectKey);
        const presenter = (0, vue_3.inject)(provider_1.groupLevelSidebarPresenterInjectKey);
        function currentPageClass(pages) {
            if (!viewModel?.value.currentPage) {
                return "";
            }
            return pages.includes(viewModel.value.currentPage) ? "active" : "";
        }
        function handleOpenGroupLevelSidebar() {
            presenter?.openSidebar();
            (0, dashboard_1.openGroupLevelSidebar)();
        }
        function handleCloseGroupLevelSidebar() {
            presenter?.closeSidebar();
            (0, dashboard_1.closeGroupLevelSidebar)();
        }
        const toggleIconClass = (0, vue_3.computed)(() => {
            return !viewModel?.value.isSidebarOpen ? "toggle-icon2-opacity" : "";
        });
        const showProLabelForCountAllLink = (0, vue_3.computed)(() => {
            return viewModel?.value.groupDashPermissions?.hasTrial || !viewModel?.value.groupDashPermissions?.hasCountAll;
        });
        const showProLabelForTimeLink = (0, vue_3.computed)(() => {
            const perms = viewModel?.value.groupDashPermissions;
            return ((perms?.hasTime && perms?.hasTrial) ||
                (!perms?.hasTime && !viewModel?.value.enableKOT));
        });
        const showTimeLink = (0, vue_3.computed)(() => {
            const hideTime = viewModel?.value.groupDashPermissions?.hasHideTime;
            return !hideTime && (viewModel?.value.groupDashPermissions?.hasTime || !viewModel?.value.enableKOT);
        });
        const hasUnpaid = (0, vue_3.computed)(() => {
            return viewModel?.value.hasUnpaid || false;
        });
        const isSidebarOpen = (0, vue_3.computed)(() => {
            return viewModel?.value.isSidebarOpen || false;
        });
        (0, vue_3.onBeforeMount)(() => {
            const pageSize = window.sessionStorage.getItem('timePageSize') || "25";
            presenter?.handlePageSizeChange(Number(pageSize));
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createVNode)(SidebarToggleIcon_vue_1.default, {
                    id: "toggle-icon",
                    onClick: handleCloseGroupLevelSidebar,
                    class: "group-sidebar-toggle-icon"
                }),
                (0, vue_2.createVNode)(SidebarToggleIcon_vue_1.default, {
                    id: "toggle-icon2",
                    onClick: handleOpenGroupLevelSidebar,
                    class: (0, vue_2.normalizeClass)(["group-sidebar-toggle-icon", toggleIconClass.value])
                }, null, 8 /* PROPS */, ["class"]),
                _cache[7] || (_cache[7] = (0, vue_2.createElementVNode)("div", { class: "divider toggle-icon-divider" }, null, -1 /* CACHED */)),
                (0, vue_2.createElementVNode)("ul", _hoisted_1, [
                    (0, vue_2.createElementVNode)("li", _hoisted_2, [
                        (0, vue_2.createElementVNode)("a", {
                            class: (0, vue_2.normalizeClass)(["group-navbar-svg", currentPageClass(['iam'])]),
                            href: `/dashboard/${(0, vue_2.unref)(viewModel)?.userId}/iam?c=${(0, vue_2.unref)(viewModel)?.branchId}`
                        }, [
                            (0, vue_2.createVNode)(BranchTallIcon_vue_1.default, { class: "sidebar-icon" }),
                            _cache[0] || (_cache[0] = (0, vue_2.createTextVNode)("拠点管理 ", -1 /* CACHED */))
                        ], 10 /* CLASS, PROPS */, _hoisted_3)
                    ]),
                    (0, vue_2.createElementVNode)("li", _hoisted_4, [
                        (0, vue_2.createElementVNode)("a", {
                            class: (0, vue_2.normalizeClass)(["group-navbar-svg", currentPageClass(['count_all', 'group_labor'])]),
                            href: `/dashboard/${(0, vue_2.unref)(viewModel)?.userId}/${(0, vue_2.unref)(viewModel)?.groupDashPermissions?.hasCountAll ? 'count_all' : 'pro'}?c=${(0, vue_2.unref)(viewModel)?.branchId}`
                        }, [
                            (0, vue_2.createVNode)(BranchSearchIcon_vue_1.default, { class: "sidebar-icon" }),
                            _cache[1] || (_cache[1] = (0, vue_2.createTextVNode)("拠点概要 ", -1 /* CACHED */)),
                            (0, vue_2.createCommentVNode)(" Free and Trial users "),
                            (showProLabelForCountAllLink.value)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_6))
                                : (0, vue_2.createCommentVNode)("v-if", true)
                        ], 10 /* CLASS, PROPS */, _hoisted_5)
                    ]),
                    (0, vue_2.createElementVNode)("li", _hoisted_7, [
                        (0, vue_2.createElementVNode)("a", {
                            class: (0, vue_2.normalizeClass)(["group-navbar-svg", currentPageClass(['group_users', 'skills'])]),
                            href: `/dashboard/${(0, vue_2.unref)(viewModel)?.userId}/${(0, vue_2.unref)(viewModel)?.groupDashPermissions?.hasPro ? 'group/users' : 'pro'}?c=${(0, vue_2.unref)(viewModel)?.branchId}`
                        }, [
                            (0, vue_2.createVNode)(StaffManagementIcon_vue_1.default, { class: "sidebar-icon" }),
                            _cache[2] || (_cache[2] = (0, vue_2.createTextVNode)(" スタッフ管理 ", -1 /* CACHED */)),
                            (!(0, vue_2.unref)(viewModel)?.groupDashPermissions?.hasPro)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_9))
                                : (0, vue_2.createCommentVNode)("v-if", true)
                        ], 10 /* CLASS, PROPS */, _hoisted_8)
                    ]),
                    (0, vue_2.createElementVNode)("li", _hoisted_10, [
                        (0, vue_2.createElementVNode)("a", {
                            class: (0, vue_2.normalizeClass)(["group-navbar-svg", currentPageClass(['group_roles'])]),
                            href: `/dashboard/${(0, vue_2.unref)(viewModel)?.userId}/${(0, vue_2.unref)(viewModel)?.groupDashPermissions?.hasPro ? 'roles?is-group-page=true&' : 'pro?'}c=${(0, vue_2.unref)(viewModel)?.branchId}`
                        }, [
                            (0, vue_2.createVNode)(RoleManagementIcon_vue_1.default, { class: "sidebar-icon" }),
                            _cache[3] || (_cache[3] = (0, vue_2.createTextVNode)("業務管理 ", -1 /* CACHED */)),
                            (!(0, vue_2.unref)(viewModel)?.groupDashPermissions?.hasPro)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_12))
                                : (0, vue_2.createCommentVNode)("v-if", true)
                        ], 10 /* CLASS, PROPS */, _hoisted_11)
                    ]),
                    (showTimeLink.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", _hoisted_13, [
                            (0, vue_2.createElementVNode)("a", {
                                class: (0, vue_2.normalizeClass)(["group-navbar-svg", currentPageClass(['time'])]),
                                href: `/dashboard/${(0, vue_2.unref)(viewModel)?.userId}/${(0, vue_2.unref)(viewModel)?.groupDashPermissions?.hasTime ? 'time?is-group-level-dashboard=true&' : 'pro?'}c=${(0, vue_2.unref)(viewModel)?.branchId}&pagesize=${(0, vue_2.unref)(viewModel)?.pagesize}`
                            }, [
                                (0, vue_2.createVNode)(TimeIcon_vue_1.default, { class: "sidebar-icon time-icon" }),
                                _cache[4] || (_cache[4] = (0, vue_2.createTextVNode)("勤怠管理 ", -1 /* CACHED */)),
                                (showProLabelForTimeLink.value)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_15))
                                    : (0, vue_2.createCommentVNode)("v-if", true)
                            ], 10 /* CLASS, PROPS */, _hoisted_14)
                        ]))
                        : (0, vue_2.createCommentVNode)("v-if", true),
                    (0, vue_2.createElementVNode)("li", _hoisted_16, [
                        (0, vue_2.createElementVNode)("a", {
                            class: (0, vue_2.normalizeClass)(["group-navbar-svg pl-1", currentPageClass(['bill'])]),
                            href: `/dashboard/${(0, vue_2.unref)(viewModel)?.userId}/bill?c=${(0, vue_2.unref)(viewModel)?.branchId}`
                        }, [
                            (0, vue_2.createElementVNode)("div", _hoisted_18, [
                                (0, vue_2.createVNode)(BillingIcon_vue_1.default),
                                (!isSidebarOpen.value && hasUnpaid.value)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("small", _hoisted_19))
                                    : (0, vue_2.createCommentVNode)("v-if", true)
                            ]),
                            _cache[5] || (_cache[5] = (0, vue_2.createTextVNode)(" 料金 ", -1 /* CACHED */)),
                            (hasUnpaid.value)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_20))
                                : (0, vue_2.createCommentVNode)("v-if", true)
                        ], 10 /* CLASS, PROPS */, _hoisted_17)
                    ]),
                    ((0, vue_2.unref)(viewModel)?.isGroupOwner)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", _hoisted_21, [
                            (0, vue_2.createElementVNode)("a", {
                                class: (0, vue_2.normalizeClass)(["group-navbar-svg", currentPageClass(['default_settings'])]),
                                href: `/dashboard/${(0, vue_2.unref)(viewModel)?.userId}/settings?branch-default=true&c=${(0, vue_2.unref)(viewModel)?.branchId}`
                            }, [
                                (0, vue_2.createVNode)(SettingsIcon_vue_1.default, { class: "sidebar-icon" }),
                                _cache[6] || (_cache[6] = (0, vue_2.createTextVNode)("設定 ", -1 /* CACHED */))
                            ], 10 /* CLASS, PROPS */, _hoisted_22)
                        ]))
                        : (0, vue_2.createCommentVNode)("v-if", true)
                ])
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
